export default __webpack_public_path__ + "static/media/patientlogin.c45f33b8.png";